import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type DrawerState = {
  isOpen: boolean
}
const initialState: DrawerState = {
  isOpen: false,
};

export const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    openDrawer: (state: DrawerState)=>{
      state.isOpen = true;
    },
    closeDrawer: (state: DrawerState)=>{
      state.isOpen = false;
    },
    toggleDrawer: (state: DrawerState)=>{
      state.isOpen = !state.isOpen;
    },
  },
});


// Action creators are generated for each case reducer function
export const { openDrawer, closeDrawer, toggleDrawer } = drawerSlice.actions
export default drawerSlice.reducer